module.exports = __webpack_public_path__ + "static/media/coin-small.11782021.png";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/coin-small.png
// module id = 625
// module chunks = 0